import {
  INeighborhoodLiteAsset,
  INeighborhoodAsset,
} from "models/Assets/INeighborhoodAsset";

const defaultFields = ["id"];

const fields_ar = [
  ...defaultFields,
  "url_name_ar",
  "name_ar",
  "name_en",
  "cities_id",
  "order",
  "order_en",
];

const fields_en = [
  ...defaultFields,
  "url_name_en",
  "name_en",
  "cities_id",
  "order",
  "order_en",
];

export const toLiteNHood = (
  nHood: INeighborhoodLiteAsset | INeighborhoodAsset,
  lang
): INeighborhoodLiteAsset => {
  if (!nHood) return null;
  const object: any = {};
  (lang === "en" ? fields_en : fields_ar).forEach((field) => {
    object.cities_id = object[field === "cities_id" ? "city_id" : field] =
      nHood[field];
  });
  return object as INeighborhoodLiteAsset;
};
